import * as React from 'react';
import { TextField } from '@mui/material';
import { ThemeTextSize } from '.';
import AppService, { textsize } from '../services/app.service';

interface Props {
  id?: string;
  name: string;
  label?: string;
  placeHolder?: string;
  value: number;
  size?: textsize;
  autoSelect?: boolean;
  box?: boolean;
  color?: any;
  readOnly?: boolean;
  disableMargin?: boolean;
  onBlur?: (fieldName?: string, value?: string) => void;
  onChange?: (fieldName: string, value?: string) => void;
  onEndTyping?: (fieldName?: string, value?: string) => void;
  error?: string;
}

export const InputNumber: React.FunctionComponent<Props> = (props) => {
  const [endTyping, setEndTyping] = React.useState<any>(null);
  const isMobile = AppService.isMobile();

  const fontSize = (size?: textsize) => {
    return ThemeTextSize(size || props.size).fontSize;
  }
  
  const onBlur = (e: React.FocusEvent<HTMLInputElement>) => { 
    props.onBlur?.(props.name, e?.target.value);
  }
  
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => { 
    const value = AppService.strToNumber(e?.target.value).toString();
    props.onChange?.(props.name, value);
        
    if (props.onEndTyping) {
      clearTimeout(endTyping);
      setEndTyping(setTimeout(() => props.onEndTyping?.(props.name, value), 500));
    }
  }

  return (
    <TextField
      id={props.id || props.name}
      name={props.name}
      label={props.label}
      type='tel'
      value={AppService.strToNumber(props.value?.toString()) }
      placeholder={props.placeHolder}
      inputProps={{spellCheck: false}}
      InputProps={{
        readOnly: props.readOnly || false,
        sx: {fontSize: fontSize(), bgcolor: props.color, borderRadius: 3, marginTop: props.box? 1.5 : 0},
        inputProps: {
          sx: { textAlign: 'right' },
        }
      }}
      InputLabelProps={{
        shrink: true,
        sx: {fontSize: fontSize() + (isMobile? 0 : 2), left: props.box? -7 : 0}
      }}
      FormHelperTextProps={{
        sx: {fontSize: fontSize(isMobile? 'medium' : 'small')}
      }}
      sx = {{'& legend': {width: props.box? 0 : undefined}}}
      margin={props.disableMargin? 'none' : 'normal'}
      variant={props.box? undefined : 'standard'}
      className='textEnd'
      fullWidth
      helperText={props.error}
      error= {props.error? true: false}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={e => {props.autoSelect && e?.target.select();}}
    />
  )
}